<div class="modal-header">
  <h4 class="modal-title">Update Profile</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="form-group">
      <label for="profile-first-name">First Name</label>
      <input ngbAutofocus type="text" class="form-control" formControlName="firstName" id="profile-first-name" placeholder="John" [ngClass]="{ 'is-invalid': formControls.firstName.touched && formControls.firstName.errors }" autocomplete="given-name">
      <div *ngIf="formControls.firstName.touched  && formControls.firstName.errors" class="invalid-feedback">
        <div *ngIf="formControls.firstName.errors.required">Name is required</div>
      </div>
    </div>
    <div class="form-group">
      <label for="profile-last-name">Last Name</label>
      <input ngbAutofocus type="text" class="form-control" formControlName="lastName" id="profile-last-name" placeholder="Smith" [ngClass]="{ 'is-invalid': formControls.lastName.touched && formControls.lastName.errors }" autocomplete="family-name">
      <div *ngIf="formControls.lastName.touched  && formControls.lastName.errors" class="invalid-feedback">
        <div *ngIf="formControls.lastName.errors.required">Last name is required</div>
      </div>
    </div>
    <div class="form-group">
      <label for="profile-email">Email Address</label>
      <input ngbAutofocus type="email" class="form-control" formControlName="email" id="profile-email" placeholder="john.smith@acme.com" [ngClass]="{ 'is-invalid': formControls.email.touched && formControls.email.errors }" autocomplete="email">
      <div *ngIf="formControls.email.touched  && formControls.email.errors" class="invalid-feedback">
        <div *ngIf="formControls.email.errors.required">Email address is required</div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button type="button" class="btn btn-link btn-sm" (click)="modal.close()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="submit()" [attr.disabled]="loading ? loading : null" [class.loading]="loading">Update Profile</button>
</div>
